var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip"},[_c('div',{staticClass:"chip__circle"}),_c('p',{staticClass:"chip__label"},[_vm._v(_vm._s(_vm.$tc('SPORTS_WEBAPP_LIVE')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }